import { useMemo } from 'react';

import {
    SearchOffersQueryResponse
} from '../../../offer/search/page/SearchOffersQuery/__generated__/SearchOffersQuery.graphql';

export const useNewBuilding = (newBuilding: SearchOffersQueryResponse['newBuilding']) => {
    return useMemo(() => {
        if (! newBuilding) {
            return {};
        }

        const isFrozen = Boolean(newBuilding.buildingStatus?.some(status => status.isFrozen));

        const hero = {
            id: newBuilding.gallery?.main?.large!,
            originPath: newBuilding.gallery?.main?.originPath!,
            src: newBuilding.gallery?.main?.large!,
            src2x: newBuilding.gallery?.main?.large!,
            description: ''
        };

        // eslint-disable-next-line max-len
        const routes = newBuilding.routes?.length && newBuilding.routes?.filter(route => route && route.station) || null;

        const developer = newBuilding.developerCards?.length && newBuilding.developerCards[0]?.developer || null;

        return {
            hero,
            routes,
            isFrozen,
            developer
        };
    }, [ newBuilding ]);
};
